import script from "./ToastStack.vue?vue&type=script&setup=true&lang=ts"
export * from "./ToastStack.vue?vue&type=script&setup=true&lang=ts"

import "./ToastStack.vue?vue&type=style&index=0&id=2db68039&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2db68039"]])

export default __exports__